<template>
  <div class="travel-history">
    <v-card class="section-card" elevation="0">
      <div class="card-head">
        <div class="head-gradient head-gradient--green" />
      </div>

      <v-divider />

      <!-- Status filter tabs -->
      <div class="status-tabs">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          :class="['tab-btn', { 'tab-btn--active': activeTab === tab.value }]"
          @click="setTab(tab.value)"
        >
          {{ tab.label }}
        </button>
      </div>

      <v-divider class="mb-5" />

      <div class="section-form pt-0">
        <!-- Loading -->
        <div v-if="loading" class="py-8 d-flex justify-center">
          <v-progress-circular indeterminate size="32" width="3" color="#F4811F" />
        </div>

        <!-- Empty -->
        <div v-else-if="filteredItems.length === 0" class="empty-wrap">
          <div class="empty-card">
            <v-icon size="40" color="#9ca3af" class="mb-2">mdi-car-off</v-icon>
            <div class="empty-title">ไม่มีรายการในสถานะนี้</div>
            <div class="empty-sub">เรียกรถรับ-ส่งได้ที่เมนู "เรียกรถ"</div>
          </div>
        </div>

        <!-- Travel list -->
        <div v-else class="orders-list">
          <div v-for="(travel, index) in pagedItems" :key="travel.id" class="order-block">
            <TravelCard :travel="travel" @refresh="fetchData" />
            <v-divider v-if="index < pagedItems.length - 1" class="my-6" />
          </div>

          <div class="pagination-row mt-6" v-if="filteredItems.length > itemsPerPage">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="7"
              prev-icon="<"
              next-icon=">"
              class="mx-2"
              color="#F4811F"
            />
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { getMyTravelsApi } from "@/services/api/travel";
import TravelCard from "./TravelCard.vue";

const STATUS_GROUPS = {
  all:        null,
  active:     ["pending", "seeking_rider", "rider_accepted", "in_progress"],
  completed:  ["completed"],
  cancelled:  ["cancelled"],
};

export default {
  name: "TravelHistory",
  components: { TravelCard },
  data() {
    return {
      loading: false,
      items: [],
      page: 1,
      itemsPerPage: 5,
      activeTab: "all",
      tabs: [
        { label: "ทั้งหมด",       value: "all" },
        { label: "กำลังดำเนินการ", value: "active" },
        { label: "สำเร็จแล้ว",    value: "completed" },
        { label: "ยกเลิกแล้ว",    value: "cancelled" },
      ],
    };
  },
  computed: {
    filteredItems() {
      const statuses = STATUS_GROUPS[this.activeTab];
      if (!statuses) return this.items;
      return this.items.filter(t => statuses.includes(t.status));
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.filteredItems.length / this.itemsPerPage));
    },
    pagedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      return this.filteredItems.slice(start, start + this.itemsPerPage);
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await getMyTravelsApi();
        this.items = Array.isArray(res?.data) ? res.data : [];
      } catch {
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    setTab(value) {
      this.activeTab = value;
      this.page = 1;
    },
  },
};
</script>

<style scoped>
.section-card {
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.06);
}

.card-head {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
}

.head-gradient {
  height: 76px;
  opacity: 0.18;
}

.head-gradient--green {
  background: linear-gradient(100deg, #d6230b 0%, #eed7d5 100%);
}

/* ─── Status tabs ─────────────────────── */
.status-tabs {
  display: flex;
  align-items: stretch;
  overflow-x: auto;
}

.tab-btn {
  flex: 1;
  min-width: 100px;
  padding: 14px 8px;
  font-size: 14px;
  font-weight: 500;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  color: #616161;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s, border-color 0.2s;
}

.tab-btn:hover { color: #F4811F; }

.tab-btn--active {
  color: #F4811F;
  border-bottom-color: #F4811F;
  font-weight: 700;
}

/* ─── Body ────────────────────────────── */
.section-form {
  padding: 22px 24px 28px;
}

.empty-wrap {
  text-align: center;
  padding: 60px 0;
}

.empty-title {
  font-size: 18px;
  font-weight: 700;
  color: #212121;
}

.empty-sub { color: #757575; }

.pagination-row {
  display: flex;
  justify-content: center;
}

::v-deep .v-pagination__item {
  box-shadow: none !important;
  border: 1px solid #e0e0e0;
}

::v-deep .v-pagination__navigation {
  box-shadow: none !important;
  border: 1px solid #e0e0e0;
}
</style>
